export default "__VITE_ASSET__N7xuRR8S__"